// Ported from prototype's `WizardSteps`. Visual marker for which wizard step
// the user is on. Step labels are fixed for the Create Agent flow.

import { Check } from 'lucide-react';
import { Fragment } from 'react';

const STEPS = ['Describe agent', 'Review blueprint', 'Connect tools', 'Test', 'Deploy'] as const;

interface Props {
  current: number; // 0-based
}

export function WizardSteps({ current }: Props) {
  return (
    <div className="flex items-center flex-wrap gap-y-3 mb-7">
      {STEPS.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <Fragment key={label}>
            <div className="flex items-center gap-2">
              <span
                className="w-[22px] h-[22px] rounded-full flex items-center justify-center text-[11px] font-semibold"
                style={{
                  background: done
                    ? 'var(--accent)'
                    : active
                      ? 'var(--accent-soft)'
                      : 'var(--surface-2)',
                  color: done
                    ? 'var(--accent-text)'
                    : active
                      ? 'var(--accent-strong)'
                      : 'var(--text-3)',
                  border: active ? '1.5px solid var(--accent)' : '1px solid var(--border)',
                }}
              >
                {done ? <Check size={11} strokeWidth={2.2} /> : i + 1}
              </span>
              <span
                className="text-[13px]"
                style={{
                  fontWeight: active ? 600 : 400,
                  color: active ? 'var(--text)' : 'var(--text-3)',
                }}
              >
                {label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <span className="w-7 h-px mx-2.5" style={{ background: 'var(--border-strong)' }} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
